module.exports = __webpack_public_path__ + "fonts/Roboto-Black.301fe70f.ttf";